import { brands } from '~/constants/brands'
import { BrandName } from '~/types'

export const getMetaBrandName = (brand: BrandName) => {
  if (brand === brands.britline) {
    return 'Britline International Payments Service'
  } else if (brand === brands.johnLewis) {
    return 'John Lewis'
  } else {
    return 'Xe'
  }
}
